/**
 * Assert that the env variable is defined and throw a noisy error if it is not
 * @param key the string key of the environment variable name, e.g. NEXT_PUBLIC_WHATEVER
 * @param val the actual value, e.g. process.env.NEXT_PUBLIC_WHATEVER
 * @returns val if it exists, otherwise throws an error
 */
export const assertEnv = (key: string, val: string | undefined) => {
  if (!val) {
    throw new Error(`Missing environment variable: ${key}`);
  }

  return val;
};
